export var normalizeTextTrackLang=function(r){return void 0===r&&(r=""),r.replace("_","-")};